"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Illustration = void 0;
var tslib_1 = require("tslib");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");
var react_1 = tslib_1.__importStar(require("react"));
var illustrations_1 = require("./illustrations");
var root_1 = require("./styled/root");
var Illustration = function (_a) {
    var className = _a.className, __UIScope = _a.__UIScope, testID = _a["data-testid"], _b = _a.scale, scale = _b === void 0 ? 30 : _b, name = _a.name, isFlexible = _a.isFlexible, 
    // 👇 Removing the space props, so they don’t get passed to VectorGraphic
    // through `...rest` and cause double spacing.
    _m = _a.m, _mb = _a.mb, _ml = _a.ml, _mr = _a.mr, _mt = _a.mt, _mx = _a.mx, _my = _a.my, _p = _a.p, _pb = _a.pb, _pl = _a.pl, _pr = _a.pr, _pt = _a.pt, _px = _a.px, _py = _a.py, rest = tslib_1.__rest(_a, ["className", "__UIScope", 'data-testid', "scale", "name", "isFlexible", "m", "mb", "ml", "mr", "mt", "mx", "my", "p", "pb", "pl", "pr", "pt", "px", "py"]);
    var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
        block: 'Illustration',
        className: className,
        __UIScope: __UIScope,
    }).rootClasses;
    var Illustration = (0, react_1.useMemo)(function () { return illustrations_1.illustrations[name]; }, [name]);
    return (react_1.default.createElement(root_1.Root, { className: rootClasses, "data-testid": testID, scale: scale, isFlexible: isFlexible },
        react_1.default.createElement(Illustration, tslib_1.__assign({}, rest))));
};
var IllustrationWithSpace = (0, ui_helper_with_space_1.withSpace)(Illustration);
exports.Illustration = IllustrationWithSpace;
//# sourceMappingURL=illustration.js.map